function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Validate',
  props: {
    value: Array
  },
  watch: {
    value: function value(n) {
      this.formValue = this.parseValue(n);
    }
  },
  data: function data() {
    return {
      formValue: {},
      option: {
        form: {
          labelPosition: 'top',
          size: 'mini',
          labelWidth: '90px'
        },
        submitBtn: false,
        formData: this.parseValue(this.value)
      },
      rule: [{
        type: 'select',
        field: 'type',
        value: undefined,
        title: '字段类型',
        options: [{
          value: undefined,
          label: '请选择'
        }, {
          value: 'string',
          label: 'String'
        }, {
          value: 'array',
          label: 'Array'
        }, {
          value: 'number',
          label: 'Number'
        }, {
          value: 'integer',
          label: 'Integer'
        }, {
          value: 'float',
          label: 'Float'
        }, {
          value: 'object',
          label: 'Object'
        }, {
          value: 'date',
          label: 'Date'
        }, {
          value: 'url',
          label: 'url'
        }, {
          value: 'hex',
          label: 'hex'
        }, {
          value: 'email',
          label: 'email'
        }],
        control: [{
          handle: function handle(v) {
            return !!v;
          },
          rule: [{
            type: 'group',
            field: 'validate',
            props: {
              expand: 1,
              rules: [{
                type: 'select',
                title: '触发方式',
                field: 'trigger',
                value: 'change',
                options: [{
                  label: 'change',
                  value: 'change'
                }, {
                  label: 'submit',
                  value: 'submit'
                }, {
                  label: 'blur',
                  value: 'blur'
                }]
              }, {
                type: 'select',
                title: '验证方式',
                field: 'mode',
                options: [{
                  value: 'required',
                  label: '必填'
                }, {
                  value: 'pattern',
                  label: '正则表达式'
                }, {
                  value: 'min',
                  label: '最小值'
                }, {
                  value: 'max',
                  label: '最大值'
                }, {
                  value: 'len',
                  label: '长度'
                }],
                value: 'required',
                control: [{
                  value: 'required',
                  rule: [{
                    type: 'hidden',
                    field: 'required',
                    value: true
                  }]
                }, {
                  value: 'pattern',
                  rule: [{
                    type: 'input',
                    field: 'pattern',
                    title: '正则表达式'
                  }]
                }, {
                  value: 'min',
                  rule: [{
                    type: 'inputNumber',
                    field: 'min',
                    title: '最小值'
                  }]
                }, {
                  value: 'max',
                  rule: [{
                    type: 'inputNumber',
                    field: 'max',
                    title: '最大值'
                  }]
                }, {
                  value: 'len',
                  rule: [{
                    type: 'inputNumber',
                    field: 'len',
                    title: '长度'
                  }]
                }]
              }, {
                type: 'input',
                title: '错误信息',
                field: 'message',
                value: ''
              }]
            },
            value: []
          }]
        }]
      }]
    };
  },
  methods: {
    onInput: function onInput(formData) {
      var val = [];
      var validate = formData.validate,
        type = formData.type;
      if (type && !validate.length) {
        return;
      } else if (type) {
        validate.forEach(function (v) {
          v.type = type;
        });
        val = _toConsumableArray(validate);
      }
      this.$emit('input', val);
    },
    parseValue: function parseValue(n) {
      var val = {
        validate: n ? _toConsumableArray(n) : [],
        type: n.length ? n[0].type : undefined
      };
      val.validate.forEach(function (v) {
        if (!v.mode) {
          Object.keys(v).forEach(function (k) {
            if (['message', 'type', 'trigger', 'mode'].indexOf(k) < 0) {
              v.mode = k;
            }
          });
        }
      });
      return val;
    }
  }
};